import { fieldUpdateApi } from "../../api/field/fieldUpdateApi"

type PayloadShape = Parameters<typeof fieldUpdateApi>[0]

export async function fieldUpdateService(payload: PayloadShape, token: string) {
	return await fieldUpdateApi(payload, token)
}
